'use strict';

import { $http } from '../app.config';
import { africaOptions } from '../globals';
import { I18n } from '../helpers/i18n';
import Model from './Model';

/**
 * Represents functionality to send contact form to team
 */
export default class Newsletter extends Model {

    /**
     * The name of subscriber
     */
    public name: string;

    /**
     * The email to subscribe
     */
    public email: string;

    constructor(private isSubscribe: boolean = true, data: { name?: string, email?: string } = {}) {
        super(data);
        this.defineField('name', {
            type: 'String',
            // validate: [
            //     {
            //         validator: 'presence',
            //         message: I18n.t('Please enter a value for field Name.'),
            //         condition() {
            //             return isSubscribe && !globalSettings.isDe;
            //         },
            //     },
            // ],
        });
        this.defineField('email', {
            type: 'String',
            validate: [
                {
                    validator: 'stringEmail',
                    allowDisplayName: false,
                    allowUtf8LocalPart: true,
                    message: I18n.t('Please enter your email address.'),
                },
            ],
        });
        this.populate(data);
    }

    /**
     * Subscribes custom to newsletter
     */
    public save(captcha?: any, isInteractive?: boolean): Promise<any> {
        return new Promise((resolve, reject) => {
            const route = this.isSubscribe ?
                africaOptions.api.routes.site.newsletterSubscribe :
                africaOptions.api.routes.site.newsletterUnsubscribe;
            const data: any = {
                contactForm: this.serialize(),
            };
            if (captcha) {
                data.captcha = captcha;
                data.isInteractive = isInteractive ?? false;
            }
            $http
                .post(route, {
                    newsletter: data,
                })
                .then((response) => {
                    resolve(response.data);
                }, () => {
                    reject();
                });
        });
    }
}
